import { baseInstance } from './baseInstance';

export const getApiKeyAPI = () => baseInstance.post('/APIKey/GetAPIKey');

export const validateApiKeyAPI = (apiKey = "") =>
    baseInstance.post(`/APIKey/ValidateApiKey?key=${apiKey}`);
